import React, { useEffect, useState } from "react";
import InputBar from "../../components/DriverAssets/InputBar";
import Button from "sushiweb/Button";
import IssuedList from "../../components/DriverAssets/IssuedList";
import AddAssetsModal from "../../components/DriverAssets/AddAssetsModal";
import BulkUploadDriverAssetsModal from "../../components/DriverAssets/BulkUploadDriverAssetsModal";
import BulkUploadDriverAssetsPickupModal from "../../components/DriverAssets/BulkUploadDriverAssetsPickupModal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverAssetsActions from "../../store/actions/DriverAssets";
import "./DriverAssets.scss";
import { getPath } from "../../utils";
import { useHistory } from "react-router";
import Permission from "../../components/Common/Permission";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";

const DriverAssets = (props) => {
  const {
    getDriverAssetsIssuedList,
    driverAssetsIssuedList,
    resetState,
    getDriverMetaData,
    getRecentAssetStatus,
  } = props;
  const [modalState, setModalState] = useState("");
  const [transactionStatus, setTransactionStatus] = useState("");
  const [bulkModalState, setBulkModalState] = useState("");
  const [driverState, setDriverState] = useState({});
  const [driverId, setDriverId] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();
  const allActions = MenuActionsMappings[MenuNames.DRIVER_ASSETS];

  const handleCredsChange = (states) => {
    resetState({ state: "driverAssetsIssuedList" });
    setError("");
    const payload = {};
    Object.keys(states).map((key) => {
      if (states[key] !== "") {
        payload[key] = states[key];
      }
    });
    setDriverState(payload);
    getDriverMetaData(payload).then((res) => {
      if (res) {
        setDriverId(res.driver_id);
        getDriverAssetsIssuedList({ driver_id: res.driver_id });
      }
    });
  };

  const handleClick = (state) => {
    const currDate = new Date();
    const toISODate = currDate.toISOString();
    //reset states
    const statesToReset = [
      "recentAssetStatus",
      "paymentStatus",
      "driverAssetsAvailableList",
      "onboardingCenters",
      "cities",
    ];
    props.resetStates({ state: statesToReset });

    getRecentAssetStatus({ driver_id: driverId }).then((res) => {
      if (res) {
        if (
          res.status === "COMPLETED" &&
          res.updated_at.split("T")[0] === toISODate.split("T")[0]
        ) {
          setError("Assets are already issued today");
        } else {
          setTransactionStatus(getPath(res, "status", ""));
          setModalState(state);
        }
      }
    });
  };

  const handleClose = () => {
    setModalState("");
  };

  const handleBulkModalClose = () => {
    setBulkModalState("");
    history.push("/driver-assets");
  };

  const getModal = () => {
    return (
      <AddAssetsModal
        transactionStatus={transactionStatus}
        driverId={driverId}
        activeDriverState={driverState}
        modalState={modalState}
        handleClose={handleClose}
      />
    );
  };

  const getBulkModal = () => {
    if (bulkModalState === "bulkUploadAssets") {
      return <BulkUploadDriverAssetsModal handleClose={handleBulkModalClose} />;
    } else if (bulkModalState === "bulkUploadAssetsPickup") {
      return (
        <BulkUploadDriverAssetsPickupModal handleClose={handleBulkModalClose} />
      );
    }
  };

  useEffect(() => {
    resetState({ state: "driverAssetsIssuedList" });
  }, []);

  useEffect(() => {
    let modalToOpen = "";
    switch (history.location.pathname) {
      case "/driver-assets-bulk":
        modalToOpen = "bulkUploadAssets";
        break;
      case "/driver-assets-bulk-pickup":
        modalToOpen = "bulkUploadAssetsPickup";
        break;
    }
    setBulkModalState(modalToOpen);
  }, [history.location.pathname]);

  return (
    <div className="Driver-Assets-View container">
      <InputBar handleSubmit={handleCredsChange} />
      <IssuedList list={driverAssetsIssuedList} />
      {getPath(driverAssetsIssuedList, "length", undefined) > 0 && (
        <Permission requiredPerms={[allActions.ISSUANCE_LIST]}>
          <Button
            data-testid="addAssetButton"
            className="sushi-btn AddBtn"
            onClick={() => handleClick("AddAssets")}
            appearance="outline"
          >
            Add Assets
          </Button>
        </Permission>
      )}
      {error && <div className="error-state">{"*" + error}</div>}
      {modalState && getModal()}
      {bulkModalState && getBulkModal()}
    </div>
  );
};

function mapStateToProps(state) {
  const { DriverAssets } = state;
  return {
    driverAssetsIssuedList: DriverAssets.driverAssetsIssuedList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverAssetsIssuedList: bindActionCreators(
      DriverAssetsActions.getDriverAssetsIssuedList,
      dispatch
    ),
    resetState: bindActionCreators(DriverAssetsActions.resetState, dispatch),
    resetStates: bindActionCreators(DriverAssetsActions.resetStates, dispatch),
    getDriverMetaData: bindActionCreators(
      DriverAssetsActions.getDriverMetaData,
      dispatch
    ),
    getRecentAssetStatus: bindActionCreators(
      DriverAssetsActions.getRecentAssetStatus,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverAssets);
